export const translations = {
    en: {
        meta: { code: "EN", label: "English" },
        nav: {
            home: "Home",
            about: "About",
            skills: "Skills",
            experience: "Experience",
            education: "Education",
            projects: "Projects",
            contact: "Contact",
            resume: "Resume",
            downloadResume: "Download Resume",
        },
        hero: {
            eyebrow: "Hi, my name is",
            roles: [
                "Full-Stack Engineer",
                "React Developer",
                "Spring Boot Developer",
                "Problem Solver",
            ],
            summary:
                "Full-stack engineer (Spring Boot + React) with 4+ years of experience. Strong ownership mindset, proficient across backend and frontend technologies, with excellent communication and collaboration skills and a passion for learning new technology.",
            viewProjects: "View Projects",
            downloadCV: "Download CV",
        },
        about: {
            eyebrow: "Get to know me",
            title: "About Me",
            languagesTitle: "Languages",
            facts: { email: "Email", phone: "Phone", location: "Location" },
            location: "Ludwigsburg, Germany",
        },
        languages: [
            { name: "English", level: "C1", value: 90 },
            { name: "German", level: "B1", value: 55 },
            { name: "Arabic", level: "Native", value: 100 },
        ],
        skills: {
            eyebrow: "What I work with",
            title: "Skills & Technologies",
            groups: {
                frameworks: "Languages & Frameworks",
                databases: "Databases",
                tools: "Tools & Platforms",
            },
        },
        experience: {
            eyebrow: "Where I've worked",
            title: "Experience",
            current: "Current",
            items: {
                cwsm: { role: "Full-Stack Engineer", company: "Car Wrapping Stuttgart", place: "Ludwigsburg, Germany" },
                sourcecode: { role: "Full-Stack Engineer", company: "Sourcecode LLC", place: "Damascus, Syria" },
                university: { role: "Teacher Volunteer", company: "Damascus University", place: "Damascus, Syria" },
                freelancer: { role: "Game Developer", company: "Freelancer", place: "Remote" },
            },
        },
        education: {
            eyebrow: "How I got here",
            title: "Education",
            items: {
                bachelor: { title: "Bachelor's Degree in Information Engineering", place: "Damascus University" },
                unicef: { title: "Additional Training", place: "Computer maintenance course at UNICEF" },
                german: { title: "B1 - German", place: "DTZ Certificate" },
            },
        },
        projects: {
            eyebrow: "Recent work",
            title: "Projects",
            moreSoon: "More soon",
            items: {
                cwsm: "CWSM",
                rehla: "Rehla",
                sourcecode: "Sourcecode",
            },
            desc: {
                cwsm: "At Car Wrapping Stuttgart, I built the entire ERP and automation system from scratch as the Project Leader and Full Stack Developer. The platform manages workshop operations, customers, scheduling, invoicing, inventory, and business automation.",
                rehla: "Rehla is an E-tourism platform for booking trips and hotels across the Middle East. I designed and developed the project as the Project Owner.",
                sourcecode: "Worked as a Full Stack Developer on a vehicle tracking platform, developing web applications and backend services for GPS tracking and fleet management.",
            },
        },
        contact: {
            eyebrow: "Get in touch",
            title: "Let's build something great together",
            text: "Currently based in {location}. Feel free to reach out for opportunities or collaborations.",
            emailMe: "Email Me",
            callMe: "Call Me",
            downloadCV: "Download CV",
        },
        footer: {
            rights: "All rights reserved.",
        },
        theme: {
            toggleToLight: "Switch to light mode",
            toggleToDark: "Switch to dark mode",
        },

    },

    de: {
        meta: { code: "DE", label: "Deutsch" },
        nav: {
            home: "Start",
            about: "Über mich",
            skills: "Fähigkeiten",
            experience: "Erfahrung",
            education: "Ausbildung",
            projects: "Projekte",
            contact: "Kontakt",
            resume: "Lebenslauf",
            downloadResume: "Lebenslauf herunterladen",
        },
        hero: {
            eyebrow: "Hallo, mein Name ist",
            roles: [
                "Full-Stack-Entwickler",
                "React-Entwickler",
                "Spring-Boot-Entwickler",
                "Problemlöser",
            ],
            summary:
                "Full-Stack-Entwickler (Spring Boot + React) mit über 4 Jahren Erfahrung. Ausgeprägtes Verantwortungsbewusstsein, versiert in Backend- und Frontend-Technologien, mit exzellenten Kommunikations- und Teamfähigkeiten sowie Leidenschaft für neue Technologien.",
            viewProjects: "Projekte ansehen",
            downloadCV: "Lebenslauf herunterladen",
        },
        about: {
            eyebrow: "Lernen Sie mich kennen",
            title: "Über mich",
            languagesTitle: "Sprachen",
            facts: { email: "E-Mail", phone: "Telefon", location: "Standort" },
            location: "Ludwigsburg, Deutschland",
        },
        languages: [
            { name: "Englisch", level: "C1", value: 90 },
            { name: "Deutsch", level: "B1", value: 55 },
            { name: "Arabisch", level: "Muttersprache", value: 100 },
        ],
        skills: {
            eyebrow: "Womit ich arbeite",
            title: "Fähigkeiten & Technologien",
            groups: {
                frameworks: "Sprachen & Frameworks",
                databases: "Datenbanken",
                tools: "Tools & Plattformen",
            },
        },
        experience: {
            eyebrow: "Wo ich gearbeitet habe",
            title: "Erfahrung",
            current: "Aktuell",
            items: {
                cwsm: { role: "Full-Stack-Entwickler", company: "Car Wrapping Stuttgart", place: "Ludwigsburg, Deutschland" },
                sourcecode: { role: "Full-Stack-Entwickler", company: "Sourcecode LLC", place: "Damaskus, Syrien" },
                university: { role: "Freiwilliger Dozent", company: "Universität Damaskus", place: "Damaskus, Syrien" },
                freelancer: { role: "Spieleentwickler", company: "Freiberuflich", place: "Remote" },
            },
        },
        education: {
            eyebrow: "Mein Werdegang",
            title: "Ausbildung",
            items: {
                bachelor: { title: "Bachelor in Informationstechnik", place: "Universität Damaskus" },
                unicef: { title: "Zusätzliche Weiterbildung", place: "Computerwartungskurs bei UNICEF" },
                german: { title: "B1 - Deutsch", place: "DTZ Zertifikat" },
            },
        },
        projects: {
            eyebrow: "Aktuelle Arbeiten",
            title: "Projekte",
            moreSoon: "Bald mehr",
            items: {
                cwsm: "CWSM",
                rehla: "Rehla",
                sourcecode: "Sourcecode",
            },
            desc: {
                cwsm: "Bei Car Wrapping Stuttgart habe ich als Projektleiter und Full-Stack-Entwickler das komplette ERP- und Automatisierungssystem von Grund auf entwickelt. Die Plattform verwaltet Werkstattabläufe, Kunden, Terminplanung, Rechnungsstellung, Lagerbestand und Geschäftsautomatisierung.",
                rehla: "Rehla ist eine E-Tourismus-Plattform zur Buchung von Reisen und Hotels im gesamten Nahen Osten. Ich habe das Projekt als Project Owner konzipiert und entwickelt.",
                sourcecode: "Als Full-Stack-Entwickler an einer Fahrzeugortungsplattform gearbeitet und Webanwendungen sowie Backend-Dienste für GPS-Tracking und Flottenmanagement entwickelt.",
            },
        },
        contact: {
            eyebrow: "Kontakt aufnehmen",
            title: "Lassen Sie uns gemeinsam etwas Großartiges schaffen",
            text: "Derzeit ansässig in {location}. Kontaktieren Sie mich gerne für Möglichkeiten oder Zusammenarbeit.",
            emailMe: "E-Mail schreiben",
            callMe: "Anrufen",
            downloadCV: "Lebenslauf herunterladen",
        },
        footer: {
            rights: "Alle Rechte vorbehalten.",
        },
        theme: {
            toggleToLight: "Zum hellen Modus wechseln",
            toggleToDark: "Zum dunklen Modus wechseln",
        },

    },
};
